export const DEFAULT_CHAT_PANE_OPEN = false;

type ChatReopenVisibilityParams = {
  isMobile: boolean;
  isChatPaneOpen: boolean;
  pathname: string;
};

export const shouldShowChatReopenButton = ({
  isMobile,
  isChatPaneOpen,
  pathname,
}: ChatReopenVisibilityParams): boolean =>
  !isMobile && !isChatPaneOpen && pathname !== "/home";
